import { __assign } from "tslib";
import React, { useContext } from 'react';
import { getComponentName } from '@wix/da-react-context/pkg/helpers';
export var SisuContext = React.createContext(false);
SisuContext.displayName = 'SisuContext';
// HOC for convenience...
export function withSisuContext(Component) {
    var DecoratedComponent = function (props) {
        var isSisu = useContext(SisuContext);
        return React.createElement(Component, __assign({ isSisu: isSisu }, props));
    };
    DecoratedComponent.displayName = "withSisuContext(".concat(getComponentName(Component), ")");
    return DecoratedComponent;
}
//# sourceMappingURL=SisuContext.js.map